module.exports = __webpack_public_path__ + "media/sub7-5-1.aa661600.mp4";